import template from './displaySystem.html';
import controller from './displaySystem.controller';
import './displaySystem.scss';

let displaySystemComponent = {
  bindings: {
    uoid: '@'
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default displaySystemComponent;



// WEBPACK FOOTER //
// ./client/app/components/displaySystem/displaySystem.component.js